(function () {
  'use strict';

  function initCommunity(section) {
    var track = section.querySelector('[data-track-scroll]');
    var prevBtn = section.querySelector('.rvrn-vip-community__arrow--prev');
    var nextBtn = section.querySelector('.rvrn-vip-community__arrow--next');
    var cardCount = track ? parseInt(track.getAttribute('data-card-count'), 10) || 0 : 0;

    function updateArrows() {
      if (!prevBtn || !nextBtn || !track) return;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    if (track && cardCount > 3) {
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var card = track.querySelector('.rvrn-vip-community__card');
          if (!card) return;
          var gap = parseInt(getComputedStyle(track).gap, 10) || 28;
          track.scrollBy({ left: -(card.offsetWidth + gap), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var card = track.querySelector('.rvrn-vip-community__card');
          if (!card) return;
          var gap = parseInt(getComputedStyle(track).gap, 10) || 28;
          track.scrollBy({ left: card.offsetWidth + gap, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    }

    track.querySelectorAll('.rvrn-vip-community__video').forEach(function (video) {
      var media = video.closest('.rvrn-vip-community__media');
      var playBtn = media ? media.querySelector('.rvrn-vip-community__play') : null;

      function syncPlayIcon() {
        if (media) media.classList.toggle('is-playing', !video.paused);
      }

      video.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.play().catch(function () {});
        });
      }

      video.addEventListener('play', syncPlayIcon);
      video.addEventListener('pause', syncPlayIcon);
      syncPlayIcon();
    });
  }

  function setup() {
    document.querySelectorAll('[data-section-type="rvrn-vip-community"]').forEach(initCommunity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
